<template>
  <div>
    <TicketForm is-customer />
  </div>
</template>

<script>
/* eslint-disable */
import TicketForm from "@/components/TicketForm.vue";

export default {
  name: "CreateTicket",
  components: {
    TicketForm,
  },
};
</script>

<style></style>
